import React, { useState, useEffect } from "react";
import "./Leads.css";
import Permiso from "../../router/Permiso";
import { View, Phone } from "lucide-react";
import { LeadService } from "../../services/LeadService";
import { useNavigate } from "react-router-dom";
import Input from "../../components/Input";
import { BarChart, Bar, XAxis, YAxis, Tooltip as RechartsTooltip,
  Legend as RechartsLegend, ResponsiveContainer } from 'recharts';
import { CircularProgressbarWithChildren, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import RadialSeparators from "./RadialSeparators";
import Select from "../../components/Select";
import Modal from "../../components/Modal";
import Dropzone from "../../components/Dropzone";
import axios from "axios";
import { buildApiUrl, getBaseUrl } from "../../config/api";
import Preloader from "../../components/Preloader";
import { toast } from "react-toastify";

const Leads = ({ token, refreshTrigger = 0 }) => {
  const [startDate, setStartDate] = useState(new Date().toISOString().slice(0, 10));
  const [endDate, setEndDate] = useState(new Date().toISOString().slice(0, 10));
  const [searchByName, setSearchByName] = useState("");
  const [state, setState] = useState("");
  const [error, setError] = useState("");
  const [errorModal, setErrorModal] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRegistros, setTotalRegistros] = useState(0);
  const [loading, setLoading] = useState(false);
  const [leads, setLeads] = useState([]);
  const [productivityList, setProductivityList] = useState([]);
  const [productivityListValues, setProductivityListValues] = useState([]);
  const [percentStatistic, setPercentStatistic] = useState(0);
  const [monthSelected, setMonthSelected] = useState(new Date().getMonth() + 1);
  const [yearSelected, setYearSelected] = useState(new Date().getFullYear());
  const [years, setYears] = useState([]);
  const [modalOpened, setModalOpened] = useState(false);
  const [modalImport, setModalImport] = useState(false);
  const [file, setFile] = useState();
  const navigate = useNavigate();
  const COLORS = ['#22b04c', '#4e79a7', '#f28e2b', '#e15759', '#76b7b2', '#59a14f', '#edc948', '#b07aa1'];

  useEffect(() => {
    getLeads();
    let tmpYears = [];
    for (let i = 2000; i <= new Date().getFullYear(); i++) {
      tmpYears.push({
        id: i,
        nombre: i
      });
    }
    setYears(tmpYears);
  }, [currentPage, refreshTrigger]);
  
  useEffect(() => {
    if (searchByName === "" && state === "") {
      getLeads();
    }
  }, [searchByName, state]);
  
  useEffect(() => {
    getStatistics();
  }, [yearSelected, monthSelected]);

  const getStatistics = async () => {
    const result = await LeadService.getStatistics({ token, yearSelected, monthSelected });
    let tmpData = [];
    result.statistic2.map((r) => {
      const name = r.name.split(' ');
      let shortName = "";
      name.map((n) => {
        shortName += n[0];
      });
      tmpData.push({
        [`${shortName}`]: r.count,
        name: r.name
      });
    });
    console.log(tmpData);
    setProductivityList(tmpData);
    setProductivityListValues(result.statistic2);

    if (result.statistic1.reported > 0) {
      setPercentStatistic(result.statistic1.reported / result.statistic1.count);
    }
  }

  const exportarExcel = async () => {
    //errorModal
    try {
      const filtros = {
        desde: startDate,
        hasta: endDate,
        state: "",
        searchByName: "",
        lead: true
      };

      const blob = await LeadService.exportar(token, filtros);
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "listado_leads.xlsx";
      document.body.appendChild(link);
      link.click();
      link.remove();
  } catch (error) {
      console.error("Error al exportar Excel:", error);
  }
};

  const FormModal = () => {
    return (
      <div className="">
        {errorModal && <div className="error-message">{errorModal}</div>}
        <Input title="Fecha de desde:" value={startDate} setValue={setStartDate} placeholder="" className="filtro-item" type="date" />
        <Input title="Fecha hasta:" value={endDate} setValue={setEndDate} placeholder="" className="filtro-item mt-10" type="date" />
      </div>
    );
  }

  const getLeads = async () => {
    setLoading(true);
    setError("");
    try {
      const { leads, totalPaginas, totalRegistros } = await LeadService.get({
        token,
        pagina: currentPage,
        pageSize: 20,
        desde: "",
        hasta: "",
        searchByName: searchByName,
        state: state,
      });

      setLeads(leads);
      setTotalPages(totalPaginas);
      setTotalRegistros(totalRegistros);
    } catch (err) {
      setError("Error al cargar las ventas");
      console.error("Error:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="ventas-admin-content">
      <div className="ventas-admin-tab-content">

        <div className="flex w-full">
          <div className="w-20">
            <div className="ventas-admin-subtitle">
              Leads
            </div>
            <p>Gestión de Leads</p>

            <div className="flex">
              <Select title="Año" value={yearSelected} setValue={setYearSelected} options={years} className="w-30"/>
              <Select title="Mes" value={monthSelected} setValue={setMonthSelected} options={[
                {
                  id: 1,
                  nombre: 'Enero'
                },
                {
                  id: 2,
                  nombre: 'Febrero'
                },
                {
                  id: 3,
                  nombre: 'Marzo'
                },
                {
                  id: 4,
                  nombre: 'Abril'
                },
                {
                  id: 5,
                  nombre: 'Mayo'
                },
                {
                  id: 6,
                  nombre: 'Junio'
                },
                {
                  id: 7,
                  nombre: 'Julio'
                },
                {
                  id: 8,
                  nombre: 'Agosto'
                },
                {
                  id: 9,
                  nombre: 'Septiembre'
                },
                {
                  id: 10,
                  nombre: 'Octubre'
                },
                {
                  id: 11,
                  nombre: 'Noviembre'
                },
                {
                  id: 12,
                  nombre: 'Diciembre'
                },
              ]} className="ml-5 w-40"/>
            </div>

          </div>
          <div className="w-20">
            <div className="ventas-admin-subtitle pb-10">
              Avance de Gestión
            </div>
            <CircularProgressbarWithChildren
              value={percentStatistic}
              text={`${percentStatistic}%`}
              strokeWidth={10}
              styles={buildStyles({
                strokeLinecap: "butt",
                pathColor: "#8a6fcb",
                textColor: "black"
              })}
            >
              <RadialSeparators
                count={12}
                style={{
                  background: "#fff",
                  width: "2px",
                  height: `${10}%`
                }}
              />
            </CircularProgressbarWithChildren>
          </div>
          <div className="w-40">
            <div className="ventas-admin-subtitle pb-10">
              Productividad
            </div>
            {
              productivityList.length > 0 && (
                <ResponsiveContainer width="100%" height={300}>
                  <BarChart data={productivityList}>
                    <XAxis dataKey="name" />
                    <YAxis />
                    <RechartsTooltip />
                    <RechartsLegend />
                    {
                      productivityListValues.map((v, index) => {
                        const name = v.name.split(' '); //fill="#22b04c"
                        let shortName = "";
                        name.map((n) => {
                          shortName += n[0];
                        });
                        return (
                          <Bar key={v.id} dataKey={shortName} fill={COLORS[index % COLORS.length]} />
                        );
                      })
                    }
                  </BarChart>
                </ResponsiveContainer>
              )
            }
          </div>
        </div>

        <div className="ventas-table-header">
            <h2 className="ventas-table-title">Lista de potenciales clientes </h2>
            <div className="productos-actions">
              <button onClick={() => {
                
              }} className="btn-filtrar">
                + Nuevo
              </button>
              <button onClick={() => setModalImport(true)} className="btn-filtrar" style={{backgroundColor: '#f56100'}}>
                Importar
              </button>
                <Permiso permiso="export_reported">
                    <button onClick={() => setModalOpened(true)} className="btn-exportar">
                        Exportar a Excel
                    </button>
                </Permiso>
            </div>
        </div>

        <div className="usuarios-filtros w-60 mt-10">
          <Input title="Buscar por nombre" value={searchByName} setValue={setSearchByName} placeholder="Ingrese el nombre del cliente" className="filtro-item" />
          <Input title="Estado leads" value={state} setValue={setState} placeholder="" className="filtro-item" />
          <div className="filtro-item">
            <button onClick={() => {
              if (state !== "" || searchByName !== "") {
                getLeads();
              }
            }} className="btn-filtrar">
              Buscar
            </button>
          </div>
        </div>

        {error && <div className="error-message">{error}</div>}

        {loading ? (
          <div className="loading">Cargando ventas...</div>
        ) : (
          <>
            <div className="ventas-table-wrapper">
              <table className="ventas-table">
                <thead>
                  <tr>
                    <th>Codigo</th>
                    <th>Vendedor</th>
                    <th>Cliente</th>
                    <th>F. Gestión</th>
                    <th>Estado</th>
                    <th>Comentarios</th>
                    <th># Contac</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {leads.map((lead, index) => {
                    return (
                      <tr key={lead.id}>
                        <td>{lead.cod_cliente}</td>
                        <td>
                          {lead.nombre_vendedor}
                        </td>
                        <td>
                          {lead.nombre} {lead.apellido_paterno} {lead.apellido_materno}
                        </td>
                        <td>{new Date(lead.fecha).toLocaleDateString()}</td>
                        <td>
                          {lead.estado}
                        </td>
                        <td>{lead.seguimiento && typeof lead.seguimiento.id !== 'undefined' ? lead.seguimiento.observacion : ''}</td>
                        <td>
                          {lead.seguimiento_count > 0 ? lead.seguimiento_count : ''}
                        </td>
                        <td className="ventas-acciones">
                          <span
                            style={{ cursor: "pointer" }}
                            onClick={() => navigate(`/admin/leads/registrar/${lead.id}/only`)}
                          >
                            <View size={20} />
                          </span>
                          <span
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              navigate(`/admin/leads/registrar/${lead.id}`);
                            }}
                          >
                            <Phone size={20} />
                          </span>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            <span style={{ marginLeft: "12px", fontSize: "14px", color: "#555" }}>
              {" "}
              Total de registros: {totalRegistros}{" "}
            </span>
            {/* Paginación */}
            <div className="pagination">
              <button
                onClick={() => setCurrentPage(currentPage - 1)}
                disabled={currentPage === 1}
              >
                Anterior
              </button>
              <span>
                Página {currentPage} de {totalPages}
              </span>
              <button
                onClick={() => setCurrentPage(currentPage + 1)}
                disabled={currentPage === totalPages}
              >
                Siguiente
              </button>
            </div>
          </>
        )}
      </div>
      <Modal
        show={modalOpened}
        title={"Seleccione rango de fechas para exportar"}
        onClickButtonAction={exportarExcel}
        textButtonAction={"Exportar"}
        onClose={() => setModalOpened(false)}
        content={<FormModal />}
      />
      <Modal
        show={modalImport}
        title={"Arrastra o selecciona el archivo"}
        onClickButtonAction={async () => {
          if (file) {
            setErrorModal('');

            const formData = new FormData();
            formData.append("file", file);

            try {
              const response = await axios.post(
                buildApiUrl("/api/leads/importar"), 
                formData,
                {
                  headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: `Bearer ${token}`,
                  },
                }
              );

              const { success, resultados } = response.data;

              if (success) {
                const errores = resultados.filter((r) => r.accion === "error");
                if (resultados.length > 0) {
                  if (errores.length > 0) {
                    toast.error(
                      <div>
                        <div style={{ fontWeight: "bold", marginBottom: "4px" }}>
                          Errores en la importación
                        </div>
                        <div style={{ fontSize: "14px" }}>
                          {errores.map((e, index) => (
                            <div key={index}>
                              Codigo: {e.documento} — Motivo: {e.motivo}
                            </div>
                          ))}
                        </div>
                      </div>,
                      {
                        position: "top-center",
                        autoClose: false,
                        hideProgressBar: false,
                        closeOnClick: false,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored",
                      }
                    );
                  }
                } else {
                  toast.success("Leads Importados Exitosamente", {
                    position: "top-center",
                    autoClose: false,
                    hideProgressBar: false,
                    closeOnClick: false,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                  });
                  getLeads();
                }
              }
              setLoading(false);
              setFile(null);
              setModalImport(false);
            } catch (error) {
              setLoading(false);
              const mensajeError =
                error.response?.data?.error || "Error inesperado al importar";
              toast.error(` ${mensajeError}`);
            }

          }
          else {
            setErrorModal("Seleccione un archivo");
          }
        }}
        textButtonAction={"Importar"}
        onClose={() => setModalImport(false)}
        content={<>
          <div style={{marginBottom: 10}}>
            <button className="btn btn-primary-compact"
              onClick={() => navigate(`${getBaseUrl()}/templates/import_leads.xlsx`)}>Descargar plantilla</button>
          </div>
          <Dropzone onFileSelect={(file) => {
            setFile(file);
          }} />
          {loading && <Preloader />}
          {errorModal && <div className="error-message">{errorModal}</div>}
        </>}
      />
    </div>
  );
};

export default Leads;
